import { Component, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { BasePage } from "../../../shared/base.page";
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { DxDataGridComponent, DxValidationGroupComponent, DxFileUploaderComponent } from 'devextreme-angular';
import { UIService } from '../../../shared/services/UIService';
import { ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { environment } from '../../../../environments/environment';
declare var CKEDITOR: any;

@Component({
    templateUrl: './scripts.page.html',
})

export class UpdateScriptsPage extends BasePage {

    @ViewChild("grid") grid: DxDataGridComponent;
    @ViewChild("frmReset") frmReset: DxValidationGroupComponent; 
    @ViewChild("fileUploader") fileUploader: DxFileUploaderComponent;


    items: any[] = [
        {
            title: "Publish as Live",
            name: "publishLive",
            icon: "icon-globe",
            showOnRow: true,
            class: "info",
        },
        {
            title: "Publish as Test",
            name: "publishTest",
            icon: "icon-globe",
            showOnRow: true,
            class: "info",
        },
        {
            title: "Validate",
            name: "validate",
            icon: "icon-check",
            class: "success",
            showOnRow: true
        },
        {
            title: "Acknowledgement",
            name: "acknowledgement",
            icon: "fa fa-check",
            showOnRow: true,
            class: "info"
        },
        {
            title: "Backup",
            name: "backup",
            icon: "fa fa-database",
            class: "info"
        }
    ]


    loadingVisible: boolean = false;
    popupLogVisible: boolean = false;
    popupEditVisible: boolean = false;
    popupAckVisible: boolean = false;
    valueContent: string = "";
    log: string = null;
    editRow: any = {};
    //
    Math: any;
    files: any[] = [];


    get uploadUrl(): string {
        return environment.api_url + "/Version/Upload";
    }


    constructor(public router: Router, serviceCaller: ServiceCaller, public uiService: UIService) {
        super(serviceCaller);
        this.Math = Math;
    }


    onMenuItemClick(e) {
        switch (e.name) {
            case "publishLive":
                {
                    let list = this.grid.instance.getSelectedRowKeys();
                    if (list.length) {
                        this.loadingVisible = true;
                        let data: any = { ID: list[0] };
                        this.api.post("/Version/Publish/Live", data).then(c => {
                            this.grid.instance.refresh();
                        }).catch(e => { }).then(c => {
                            this.loadingVisible = false;
                        });
                    }
                    break;
                }
            case "publishTest":
                {
                    let list = this.grid.instance.getSelectedRowKeys();
                    if (list.length) {
                        this.loadingVisible = true;
                        let data: any = { ID: list[0] };
                        this.api.post("/Version/Publish/Test", data).then(c => {
                            this.grid.instance.refresh();
                        }).catch(e => { }).then(c => {
                            this.loadingVisible = false;
                        });
                    }
                    break;
                }
            case "validate":
                {
                    let list = this.grid.instance.getSelectedRowKeys();
                    if (list.length) {
                        this.loadingVisible = true;
                        let params: any = { ID: list[0] };
                        this.api.post("/Version/Validate", params).then((data) => {
                            if (data.error) {
                                this.uiService.error(data.error);
                            }
                            else {
                                this.uiService.success();
                            }
                            this.grid.instance.refresh();
                        }).catch(e => { }).then(c => {
                            this.loadingVisible = false;
                        });
                    }
                    break;
                }
            case "backup":
                {
                    this.loadingVisible = true;
                    this.api.post("/Version/Backup").then((data) => {
                        if (data.error) {
                            this.uiService.error(data.error);
                        }
                        else {
                            this.uiService.success();
                        }
                    }).catch(e => { }).then(c => {
                        this.loadingVisible = false;
                    });
                    break;
                }
            case "DXInsert":
                {
                    e.handled = true;
                    this.popupEditVisible = true;
                    break;
                }
            case "DXEdit":
                {
                    e.handled = true;
                    let list = this.grid.instance.getSelectedRowKeys();
                    if (list.length) {
                        Object.assign(this.editRow, this.grid.instance.getSelectedRowsData()[0]);
                        this.popupEditVisible = true;
                    }
                    break;
                }
            case "acknowledgement": {
                e.handled = true;
                let list = this.grid.instance.getSelectedRowKeys();
                this.api.get("/Version/Acknowledgement", { ID: list[0] }).then((data) => {
                        this.popupAckVisible = true; 
                        setTimeout(() => {
                            if(CKEDITOR.instances["option_text"])
                                CKEDITOR.instances["option_text"].destroy();
                            CKEDITOR.config.uiColor= '#39b2d5';
                            CKEDITOR.config.height='400px';
                            CKEDITOR.config.forcePasteAsPlainText =true;
                            CKEDITOR.config.allowedContent =true 
                            CKEDITOR.config.docType = '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">';
                            CKEDITOR.replace('option_text'); 
                            CKEDITOR.instances["option_text"].setData(data);
                    }, 200);                      
                });
                break;
            } 
        }
    }

    

    showLog(row: any) {
        this.log = row.Log;
        this.popupLogVisible = true;
    }

    save() {
        if (this.frmReset.instance.validate().isValid) {
            this.loadingVisible = true;
            this.api.post("/Version/Save", this.editRow).then(() => {
                this.grid.instance.refresh();
                this.popupEditVisible = false;
            }).catch(e => { }).then(c => {
                this.loadingVisible = false;
            });
        }

    }

    onRemoveClick() {
        this.fileUploader.instance.reset();
        this.editRow.FileId = null;
    }

    onUploaded(e) {
        try {
            var json = JSON.parse(e.request.response);
            if (json.Succeed) {
                this.editRow.FileId = json.Result;
            }
            else {
                this.fileUploader.instance.reset();
                this.uiService.error(json.Message.Text);
            }
        } catch (error) {
            this.fileUploader.instance.reset();
            this.uiService.error(error.message);
        }

    }

    saveAck() {  
        let context=CKEDITOR.instances["option_text"].getData();
        if (context!=null) {
            this.loadingVisible = true;
            let list = this.grid.instance.getSelectedRowKeys();
            let param={ID:list[0],Acknowledgement:context}
          
            this.api.post("/Version/AcknowledgementSave", param).then(() => { 
                this.popupAckVisible = false;
                this.loadingVisible = false;
            }).catch(e => { }).then(c => {
                this.loadingVisible = false;
            });
        }

    }

    cancelAck() {
        this.popupAckVisible = false;
    }

}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Database/scripts.page.ts